import type { BadStatusError } from '@confluence/network';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import { convertToApolloError } from './convertToApolloError';

export type TransformErrorType = (
	error: Error | BadStatusError,
) => Promise<Error | BadStatusError> | Error | BadStatusError;

export const handleError = async ({
	error,
	transformError,
	onError,
}: {
	error: Error | BadStatusError;
	transformError?: TransformErrorType;
	onError?: (error: ApolloErrorInterop) => void;
}) => {
	// The `transformError` callback can optionally return a new error to replace the original,
	// allowing for custom errors (e.g. based on the error's status code)
	const finalError = convertToApolloError((await transformError?.(error)) || error);
	onError?.(finalError);
	return finalError;
};
